module.exports = __webpack_public_path__ + "img/transparent_cell.d1c8b3fb.png";